import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
	return (
		<div className="bg-white text-slate-800">
			<Navbar />
			<Hero />
			<About />
			<Services />
			<Contact />
			<Footer />
		</div>
	);
}

export default App;
